/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import {
  convertStringToArray,
  convertStringToArrayForOption,
  convertStringToArrayForRadio,
  getConcatenatedStringFromValues,
  getNumberLengthFromString,
  isEmptyObject,
  loadIfStateAvailableInSessionStorage,
  savePageStateInSessionStorage,
  Translations
} from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import Inputbox from '../../../common/InputBox/inputTextbox';
import MultiLineSelect from '../../../common/MultiLineSelect';
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';
import PersistLink from '../../../common/PersistLink';
import PrefixedInputBox from '../../../common/PrefixedInputBox';
import Radiobutton from '../../../common/Radio/radioButton';
import SimpleDropdown from '../../../common/SimpleDropdown';
import SingleLineSelect from '../../../common/SingleLineSelect';
import Tooltip from '../../../common/Tooltip';
import { CopytoAccountModal } from '../../Modals';
//action Creator
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
import { resetAccountPaperStatement, setCountryInfo, setCurrencyInfo } from '../../../createAcase/actions/actionCreator';
import { hideActionButton } from '../../../layouts/actions/actionCreator';
import {
  resetCurrentProductAccount,
  reSetNewAccountActiveTabIndex,
  setAddresses,
  setCurrentProductAccount,
  setCurrentProductAccountEchannels,
  setCurrentProductAccountStatuses,
  setNewAccountActiveTabIndex,
  setPersons
} from '../../actions/actionCreator';

//style
import './styles.css';

class CaptureProductNewAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setDisabledonFlag: [],
      CopytoAccountModalDailog: false,
      pageAccountAndAddressFormJson: {},
      pageAccountSignatoryFormJson: {},
      pageEchannelReportingFormJson: {},
      basicDetails: undefined,
      currentAccount: {
        eChannelReporting: [],
        accountSignatories: [],
        accountSpecificContactDesignated: false
      },
      restrictions: [],
      noOfAccountSignatories: 1,
      showAddAccountSignatoryBtn: false,
      noOfEchannelReportings: 1,
      showAddEchannelBtn: false,
      showPaperStamentsAndChequeBooksSection: false,
      mandateStructure: [],
      copyData: [],
      to: [],
      showTooltip: false,
      disabledAccountSignatory: [],
      disabledeChannelReporting: [],
      taxanomyURL: '',
      countrytaxanomyList: []
    };
    this.disableList = []
    this.reportingEchannelDisableList = []
    this.filterProductdetails = [];
    this.mandateStructure = [
      {
        description: "Any one to sign",
        id: "any-1-to-sign"
      },
      {
        description: "Any two to sign",
        id: "any-2-to-sign"
      },
      {
        description: "Signature grouping",
        id: "group-signature"
      },
      {
        description: "I will attach my own mandate",
        id: "own-mandate"
      }
    ];
  }

  toggleTooltiponEnter = (event) => {
    if (event.keyCode === 27) {
      var selector = `[data-tooltip=copyData]`
      document.querySelectorAll(selector)[0].setAttribute("aria-expanded", false)
      this.setState({
        showTooltip: false
      })
    }
  }

  toggleTooltip = () => {
    var selector = `[data-tooltip=copyData]`
    document.querySelectorAll(selector)[0].setAttribute("aria-expanded", !this.state.showTooltip)
    this.setState({
      showTooltip: !this.state.showTooltip
    })
  }

  loadPageState = () => {
    var { productId } = this.props.match.params;
    eapiClient("/product/account/" + productId)
      .then(({ data }) => {
        const { country = {}, currency = {}, accountType = {} } = data.responseData;
        if (country.value !== undefined && country.value !== '' && accountType.value !== undefined && accountType.value !== '' && currency.value !== undefined && currency.value !== '') {
          taxonomyHostClient("/product/taxonomies?country=" + country.value + "&account=" + accountType.value + "&currency=" + currency.value)
            .then(({ data: { responseData } }) => {
              if (responseData.paperStatementsFrequency.length !== 0 || responseData.chequeBookTypes.length !== 0) {
                this.setState({ showPaperStamentsAndChequeBooksSection: true, noOfChequeBooks: responseData.numberOfChequeBooks, numberOfPaperStatements: responseData.numberOfPaperStatements });
              }
            });
        }
        data.responseData.productId = productId;
        let disAcc = data.responseData.accountSignatories.map(item => item.id);
        this.disableList = disAcc;
        let disReportingEchannel = data.responseData.eChannelReporting.map(item => {
          if (item.productMap) {
            let disableDisplay = false;
            for (let [key, value] of Object.entries(item.productMap)) {
              if (value === "Account") {
                disableDisplay = true;
                break;
              }
            }
            if (disableDisplay || Object.keys(item.productMap).length <= 0) {
              return item.eChannelId
            }
          } else if (!item.productMap) {
            return item.eChannelId
          }
        })
          .filter((filterItem) => {
            if (filterItem) {
              return filterItem
            }
          });
        this.reportingEchannelDisableList = disReportingEchannel;
        let notOnlyGLSEnabledAcc = data.responseData.eChannelReporting.filter(item => {
          if (item.productMap) {
            let disableDisplay = false;
            for (let [key, value] of Object.entries(item.productMap)) {
              if (value === "Account") {
                disableDisplay = true;
                break;
              }
            }
            if (disableDisplay || Object.keys(item.productMap).length <= 0) {
              return item
            }
          } else if (!item.productMap) {
            return item
          }
        });

        if (notOnlyGLSEnabledAcc && notOnlyGLSEnabledAcc.length && this.props.productDetails.echannel && this.props.productDetails.echannel.length) {
          notOnlyGLSEnabledAcc.forEach(acc => {
            if (isEmptyObject(acc.eChannelType)) {
              const selectedEchannel = this.props.productDetails.echannel.find(echannel => echannel.id === acc.eChannelId);
              if (selectedEchannel && !isEmptyObject(selectedEchannel.eChannelType)) {
                acc.eChannelType = selectedEchannel.eChannelType.name

              }
            }
          })
        }
        this.setState({
          currentAccount: { ...data.responseData, eChannelReporting: notOnlyGLSEnabledAcc },
          paperStatementChequeBooks: data.responseData.paperStatementChequeBooks,
          disabledAccountSignatory: disAcc,
          disabledeChannelReporting: disReportingEchannel,
          basicDetails: data.responseData,
          countryName: data.responseData.country.name
        });
        this.props.setCurrentProductAccount(data.responseData);


        return aemHostClient("/aemData/formData/json_account-details")
      }).then(({ data }) => {
        this.setState({ pageJson: data });
        this.getCountryListForEhannel();
        this.getAccountCountryTaxanomy();
        this.getCountryListForAddress();
      });
  }

  componentWillMount() {
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });

    aemHostClient("/aemData/formData/json_account-details")
      .then(({ data }) => {
        this.setState({ pageJson: data });
        this.getCountryListForEhannel();
        this.getAccountCountryTaxanomy();
        this.getCountryListForAddress();

        return aemHostClient("/aemData/formData/json_account-copy-to-from")
      })
      .then(({ data }) => {
        this.setState({ copyToaccountformJson: data });

        return aemHostClient("/aemData/formData/json_account-address-and-contacts-form")
      }).then(({ data }) => {
        this.setState({ pageAccountAndAddressFormJson: data });

        return aemHostClient("/aemData/formData/json_account-signatories-form")
      }).then(({ data }) => {
        this.setState({
          pageAccountSignatoryFormJson: data
        });

        return aemHostClient("/aemData/formData/json_echannel-reporting-accordian-page")
      }).then(({ data }) => {
        this.setState({ pageEchannelReportingFormJson: data });
      }).catch((err) => console.log(err))
  }

  componentDidMount() {
    var { caseId, productId } = this.props.match.params;

    eapiClient("/product/account/" + productId + "/accountDetailsStatus")
      .then(({ data }) => {
        this.props.setCurrentProductAccountStatuses(data.responseData);

        return eapiClient("/addresses/case/" + caseId)
      }).then(({ data }) => {
        this.props.setAddresses(data.responseData)

        return eapiClient("/persons/case/" + caseId)
      })
      .then(({ data }) => {
        this.props.setPersons(data.responseData);

        return eapiClient("/product/caseRelatedEchannel/case/" + caseId)
      }).then(({ data }) => {
        if (Array.isArray(data.responseData) && data.responseData.length) {
          let setDisabledonFlag = data.responseData.map(item => {
            if (item.render === false) {
              return item.id
            }
          })
          this.setState({ setDisabledonFlag });
          this.props.setCurrentProductAccountEchannels(data.responseData);
        }
      })


    this.props.hideActionButton();
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownType = window.sessionStorage.getItem("getCurrentDropDownType");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    var getCurrentDropDownType = window.sessionStorage.getItem("getCurrentDropDownType");
    var getCurrentDropDownTypeValue = window.sessionStorage.getItem('keyType' + getCurrentDropDownType);

    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName;
      if (isNaN(parseInt(getCurrentDropDown.substring(getCurrentDropDown.length - 1)))) {
        getCurrentDropDownName = getCurrentDropDown;
      } else {
        //The function getNumberLengthFromString gets length of number appended at last with the given string, e.g achAccountsId11 -> returns 2
        var _indexLength = getNumberLengthFromString(getCurrentDropDown);
        getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - _indexLength);
      }
    }
    if (getCurrentDropDownName === 'eChannelReporting' || getCurrentDropDownName === 'accountSignatories') {
      var getCurrentDropDownIndex;
      getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - _indexLength);
    }

    if (getCurrentDropDown === 'accountAddress' && this.state.currentAccount.accountSpecificAddress !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
      this.setState({
        currentAccount: {
          ...this.state.currentAccount,
          accountSpecificAddress: getCurrentDropDownValue
        }
      });
    }
    if (getCurrentDropDown === 'accountSpecificContact' && this.state.currentAccount.accountSpecificContact !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
      this.setState({
        currentAccount: {
          ...this.state.currentAccount,
          accountSpecificContact: getCurrentDropDownValue
        }
      });
    }

    var _accountSignatories = [...this.state.currentAccount.accountSignatories];
    var _eChannelReporting = [...this.state.currentAccount.eChannelReporting];

    if (this.state.currentAccount.accountSignatories.length > 0 && getCurrentDropDown !== 'accountSpecificContact' && getCurrentDropDown !== 'accountAddress' && getCurrentDropDownName !== 'eChannelReporting') {
      this.state.currentAccount.accountSignatories.forEach((currentValue, index, arr) => {
        if (currentValue.id !== getCurrentDropDownValue && index === getCurrentDropDown - 1) {
          _accountSignatories[index] = { id: getCurrentDropDownValue };
          let disableItem = _accountSignatories.map(item => item.id)
          this.disableList = disableItem
          this.setState({
            currentAccount: {
              ...this.state.currentAccount,
              accountSignatories: _accountSignatories
            },
            disabledAccountSignatory: disableItem,
            showAddAccountSignatoryBtn: true
          });
        } else if (getCurrentDropDownValue !== null && getCurrentDropDown !== 'accountSpecificContact' && getCurrentDropDown !== 'accountAddress' && getCurrentDropDownName !== 'eChannelReporting') {
          _accountSignatories[getCurrentDropDownIndex - 1] = { id: getCurrentDropDownValue };
          let disableItem = _accountSignatories.map(item => item.id)
          this.disableList = disableItem
          this.setState({
            currentAccount: {
              ...this.state.currentAccount,
              accountSignatories: _accountSignatories
            },
            disabledAccountSignatory: disableItem,
            showAddAccountSignatoryBtn: true
          });
        }
      })
    } else if (getCurrentDropDown !== 'accountSpecificContact' && getCurrentDropDown !== 'accountAddress' && getCurrentDropDownName !== 'eChannelReporting' && getCurrentDropDownValue !== null) {
      _accountSignatories[getCurrentDropDownIndex - 1] = { id: getCurrentDropDownValue };
      let disableItem = _accountSignatories.map(item => item.id)
      this.disableList = disableItem
      this.setState({
        currentAccount: {
          ...this.state.currentAccount,
          accountSignatories: _accountSignatories
        },
        disabledAccountSignatory: disableItem,
        showAddAccountSignatoryBtn: true
      });
    } if (getCurrentDropDownName === 'eChannelReporting' && this.state.currentAccount.eChannelReporting.length > 0) {
      this.state.currentAccount.eChannelReporting.forEach((currentValue, index, arr) => {
        if (currentValue.eChannelId !== getCurrentDropDownValue && index === getCurrentDropDown - 1) {
          _eChannelReporting[index] = { eChannelId: getCurrentDropDownValue, eChannelType: getCurrentDropDownTypeValue };
          let disableItem = _eChannelReporting.map(item => item.eChannelId)
          this.reportingEchannelDisableList = disableItem
          this.setState({
            currentAccount: {
              ...this.state.currentAccount,
              eChannelReporting: _eChannelReporting
            },
            disabledeChannelReporting: disableItem,
            showAddEchannelBtn: true
          });
        } else if (getCurrentDropDownValue !== null && getCurrentDropDownName === 'eChannelReporting') {
          _eChannelReporting[getCurrentDropDownIndex - 1] = { eChannelId: getCurrentDropDownValue, eChannelType: getCurrentDropDownTypeValue };
          let disableItem = _eChannelReporting.map(item => item.eChannelId)
          this.reportingEchannelDisableList = disableItem
          this.setState({
            currentAccount: {
              ...this.state.currentAccount,
              eChannelReporting: _eChannelReporting
            },
            disabledeChannelReporting: disableItem,
            showAddEchannelBtn: true
          });
        }
      })
    } else if (getCurrentDropDownName === 'eChannelReporting' && getCurrentDropDownValue !== null) {
      _eChannelReporting[getCurrentDropDownIndex - 1] = { eChannelId: getCurrentDropDownValue, eChannelType: getCurrentDropDownTypeValue };
      let disableItem = _eChannelReporting.map(item => item.eChannelId)
      this.reportingEchannelDisableList = disableItem
      this.setState({
        currentAccount: {
          ...this.state.currentAccount,
          eChannelReporting: _eChannelReporting
        },
        disabledeChannelReporting: disableItem,
        showAddEchannelBtn: true
      });
    }
    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
    window.sessionStorage.removeItem("getCurrentDropDownType");
    window.sessionStorage.removeItem('keyType' + getCurrentDropDownType);
  }
  saveStateToSessionOnEdit = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }

  componentWillReceiveProps(nextProps) {
    const _eChannelReporting = this.state.currentAccount.eChannelReporting
      .map(item => {
        if (item.productMap) {
          let disableDisplay = true;
          for (let [key, value] of Object.entries(item.productMap)) {
            if (value === "Account") {
              disableDisplay = false;
              break;
            }
          }
          if (!disableDisplay || Object.keys(item.productMap).length <= 0) {
            return item.eChannelId
          }
        } else if (!item.productMap) {
          return item.eChannelId
        }
      })
      .filter((filterItem) => {
        if (filterItem) {
          return filterItem
        }
      });
    this.reportingEchannelDisableList = _eChannelReporting;
    var showAddEchannelBtn = false;
    if (_eChannelReporting.length > 0) {
      showAddEchannelBtn = true;
      if (this.state.noOfEchannelReportings === _eChannelReporting.length) {
        this.setState({ showAddEchannelBtn });
      }
    }
    if (_eChannelReporting && _eChannelReporting.length > 0 && this.state.noOfEchannelReportings !== _eChannelReporting.length) {
      this.setState({
        noOfEchannelReportings: _eChannelReporting.length,
        showAddEchannelBtn
      });
    }

    const _accountSignatories = this.state.currentAccount.accountSignatories;
    if (_accountSignatories.length > 0) {
      var showAddAccountSignatoryBtn = true;
      if (this.state.noOfEchannelReportings === _accountSignatories.length) {
        this.setState({ showAddAccountSignatoryBtn });
      }
    }
    if (_accountSignatories && _accountSignatories.length > 0 && this.state.noOfAccountSignatories !== _accountSignatories.length) {
      this.setState({
        noOfAccountSignatories: _accountSignatories.length,
        showAddAccountSignatoryBtn
      });
    }

    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getCountryListForEhannel();
      this.getCountryListForAddress();
      this.getAccountCountryTaxanomy();
    }
  }

  getBasicDetails = (basicDetails) => {
    this.setState({ basicDetails });
  }

  getCountryListForEhannel = () => {
    let _currentEchannel = { ...this.props.currentProductAccount };
    let taxanomyURL = this.translations(this.state.pageJson.par.aemform_echannelReporting.countryTaxonomy)
    taxonomyHostClient(taxanomyURL)
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let currentListCountries = data.responseData.classificationNodes;
          this.setState({ countrytaxanomyList: currentListCountries })
          _currentEchannel = _currentEchannel.echannels.map(item => {
            currentListCountries.map(country => {
              if (country.id === item.country.value) {
                item.country.name = country.name
              }
            })
          })
        }
      });
    this.setState({ taxanomyURL, });
    this.props.setCurrentProductAccountEchannels([..._currentEchannel.echannels]);
  }

  getCountryListForAddress = () => {
    let _currentAddress = [...this.props.addresses];
    let _persons = [...this.props.persons]
    let taxanomyURL = this.translations(this.state.pageJson.par.aemform_echannelReporting.countryTaxonomy);
    taxonomyHostClient(taxanomyURL)
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let currentListCountries = data.responseData.classificationNodes;
          this.setState({ countrytaxanomyList: currentListCountries })
          _currentAddress = _currentAddress.map(item => {
            currentListCountries.map(country => {
              if (country.id === item.country.value) {
                item.country.name = country.name
              }
            })
          });

          if (_persons !== undefined) {
            _persons = _persons.map(item => {
              if ('nationality' in item) {
                currentListCountries.map(country => {
                  if (country.id === item.nationality.value) {
                    item.nationality.name = country.name
                  }
                  if (country.id === item.countryOfResidence.value) {
                    item.countryOfResidence.name = country.name
                  }
                })
              }
            })
          }
        }
      });
    this.setState({ taxanomyURL })
    this.props.setAddresses([..._currentAddress]);
    this.props.setPersons([..._persons]);
  }


  getPaperData = (paperStatementChequeBooks) => {
    this.setState({ paperStatementChequeBooks });
  }

  handleAccountAddressEditClick = (accountAddress) => {
    if (accountAddress) {
      this.saveStateToSessionOnEdit();
      this.props.history.push("/case-body/create-new-product-address/" + accountAddress.id);
    }
  }

  handleAccountContactEditClick = (accountContact) => {
    if (accountContact) {
      this.saveStateToSessionOnEdit();
      this.props.history.push("/case-body/create-new-product-contact/" + accountContact);
    }
  }

  handleAccountSignatoryEditClick = (accountSignatory) => {
    if (accountSignatory) {
      this.saveStateToSessionOnEdit();
      this.props.history.push("/case-body/create-new-product-signatory/" + accountSignatory.id);
    }
  }

  handleAccountAddressChange = ({ id }) => {
    this.setState({ currentAccount: { ...this.state.currentAccount, accountSpecificAddress: id } });
  }

  handleAccountContactChange = ({ id }) => {
    this.setState({ currentAccount: { ...this.state.currentAccount, accountSpecificContact: id } });
  }

  handleAccountSignatoryChange = (index, accountSignatory) => {
    var _accountSignatories = [...this.state.currentAccount.accountSignatories];
    _accountSignatories[index] = { id: accountSignatory.id };

    this.disableList.indexOf(accountSignatory.id) === -1 && this.disableList.includes(accountSignatory.id)
      ? this.disableList.push(accountSignatory.id)
      : this.disableList

    this.disableList[index] = accountSignatory.id

    this.setState(prevState => ({
      disabledAccountSignatory: this.disableList,
      currentAccount: { ...this.state.currentAccount, accountSignatories: _accountSignatories },
      showAddAccountSignatoryBtn: true,
    }));

  }

  handleAccountEchannelReportingChange = (index, accountEchannel) => {
    var _eChannelReporting = [...this.state.currentAccount.eChannelReporting];
    _eChannelReporting[index] = { eChannelId: accountEchannel.id };
    _eChannelReporting[index].eChannelType = accountEchannel.eChannelType.name

    this.reportingEchannelDisableList.indexOf(accountEchannel.id) === -1 && this.reportingEchannelDisableList.includes(accountEchannel.id)
      ? this.reportingEchannelDisableList.push(accountEchannel.id)
      : this.reportingEchannelDisableList

    this.reportingEchannelDisableList[index] = accountEchannel.id;
    this.setState({
      disabledeChannelReporting: this.reportingEchannelDisableList,
      currentAccount: { ...this.state.currentAccount, eChannelReporting: _eChannelReporting },
      showAddEchannelBtn: true
    });
  }

  setMandateStructure = (event) => {
    const mandateStructure = { id: event.target.value, value: event.target.value };
    this.setState({ currentAccount: { ...this.state.currentAccount, mandateStructure } });
  }

  setAccountSignatoryGroup = (index, event) => {
    const group = {
      id: event.target.value,
      value: event.target.value
    }
    let _accountSignatories = [...this.state.currentAccount.accountSignatories];
    if (!_accountSignatories[index - 1]) {
      _accountSignatories[index - 1] = { group };
    } else {
      _accountSignatories[index - 1].group = group;
      _accountSignatories[index - 1].restriction = undefined;
    }
    this.setState({ currentAccount: { ...this.state.currentAccount, accountSignatories: _accountSignatories } });
  }

  setRestriction = (index, event) => {
    const restriction = event.target.value;
    let _accountSignatories = [...this.state.currentAccount.accountSignatories];
    if (!_accountSignatories[index - 1]) {
      _accountSignatories[index - 1] = { restriction };
    } else {
      _accountSignatories[index - 1].restriction = restriction;
      _accountSignatories[index - 1].group = undefined;
    }
    this.setState({ currentAccount: { ...this.state.currentAccount, accountSignatories: _accountSignatories } });
  }

  checkPaperStatement(payload) {
    let countryInfo = this.props.countryInfo;
    let accountType = countryInfo.filter(x => x.id === payload.data && payload.data.accountType && payload.data.accountType.value);
    let countryCurrency = accountType.length > 0 ? accountType[0].associations.find(x => x.id === payload.data && payload.data.currency && payload.data.currency.value) : "";
    if (countryCurrency !== undefined && countryCurrency !== "" && countryCurrency !== null && countryCurrency.paperStatement !== undefined) {
      if (countryCurrency.paperStatement.chequeBookTypes.length === 0 && countryCurrency.paperStatement.numberOfChequeBooks.length === 0 && countryCurrency.paperStatement.numberOfPaperStatements.length === 0 && countryCurrency.paperStatement.paperStatementsFrequency.length === 0) {
        return false;
      }
      else {
        return true
      }
    }
  }

  // Basic detail Form submit
  onBasicDetailTabDataSubmit = (event, apiUrl) => {
    this.props.blockUi();
    let accountPaperStatement = this.props.accountPaperStatement;
    let payload = new BasicDetail();
    payload.setBasicDetailPayload(this.state);
    var { productId } = this.props.match.params;
    let isPaperStatemet = this.checkPaperStatement(payload);
    if (isPaperStatemet === false || accountPaperStatement === true) {
      delete payload.data.paperStatementChequeBooks;
    }
    eapiClient(apiUrl + '/' + productId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        //tab statuses
        eapiClient(apiUrl + '/' + productId + "/accountDetailsStatus")
          .then(({ data }) => {
            this.props.setCurrentProductAccountStatuses(data.responseData);
            this.props.unBlockUi();
          });
      });
  }

  // Account Address And Contacts
  onAccountAddressAndContactsTabDataSubmit = (event) => {
    this.props.blockUi();
    let payload = new AccountAddressAndContact();
    payload.setAccountAddressAndContact(this.state);
    var { productId } = this.props.match.params;

    eapiClient("/product/account/" + productId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        //tab statuses
        eapiClient("/product/account/" + productId + "/accountDetailsStatus")
          .then(({ data }) => {
            this.props.setCurrentProductAccountStatuses(data.responseData);
          });
        this.props.unBlockUi();
      });
  }

  // Paper Statement Form Submit
  onPaperStatementTabDataSubmit = (event, apiUrl) => {
    this.props.blockUi();
    let payload = new PaperStatementAndChequeBooks();
    payload.setPaperStatementAndChequeBooks(this.state);
    var { productId } = this.props.match.params;
    let paperData = payload.data;
    if (paperData.paperStatementChequeBooks !== undefined && paperData.paperStatementChequeBooks.paperStatementFrequency !== undefined) {
      if (paperData.paperStatementChequeBooks.paperStatementFrequency.value === "NR") {
        delete paperData.paperStatementChequeBooks.numberOfPaperStatements;
        delete paperData.paperStatementChequeBooks.perfferedDate;
        delete paperData.paperStatementChequeBooks.deliverTo;
        paperData.paperStatementChequeBooks.attentionOf = "";
      }
    }
    eapiClient(apiUrl + productId, {
      method: 'PUT',
      data: JSON.stringify(paperData)
    })
      .then(({ data }) => {
        //tab statuses
        eapiClient(apiUrl + productId + "/accountDetailsStatus")
          .then(({ data }) => {

            this.props.setCurrentProductAccountStatuses(data.responseData);
            this.props.unBlockUi();
          });
      });
  }

  getAccountCountryTaxanomy = () => {
    taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_basicDetails.accountTaxonomy))
      .then(({ data }) => {
        this.setState({ countryAccountList: data.responseData.countryTaxonomy.classificationNodes })
        this.getTranslatedAccounts();
      });
  }

  getTranslatedAccounts = () => {
    let currentAccount = this.state.currentAccount;
    if (this.state.countryAccountList !== undefined) {
      if (currentAccount !== undefined) {

        this.state.countryAccountList.filter(countItem => {
          if ('country' in currentAccount) {
            if (countItem.id === currentAccount.country.value) {
              currentAccount.country.name = countItem.name
              if (currentAccount.accountType !== undefined) {
                countItem.associations.filter(accountType => {
                  if (accountType.id === currentAccount.accountType.value) {
                    currentAccount.accountType.name = accountType.name
                  }
                })
              }
            }
          }
          return currentAccount;
        });
        this.setState({ currentAccount });
      }
    }
  }

  // Account Signatory
  onAccountSignatoryTabDataSubmit = (event) => {
    this.props.blockUi();
    let payload = new AccountSignatoy();
    payload.setAccountSignatoy(this.state);
    var { productId } = this.props.match.params;

    eapiClient("/product/account/" + productId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        //tab statuses
        eapiClient("/product/account/" + productId + "/accountDetailsStatus")
          .then(({ data }) => {
            this.props.setCurrentProductAccountStatuses(data.responseData);
            this.props.unBlockUi();
          });
      });
  }

  // E-Channel Reporting
  onEchannelReportingTabDataSubmit = (event) => {
    this.props.blockUi();
    let payload = new EchannelReporting();
    payload.setEchannelReporting(this.state);

    var { productId } = this.props.match.params;

    eapiClient("/product/account/" + productId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        //tab statuses
        eapiClient("/product/account/" + productId + "/accountDetailsStatus")
          .then(({ data }) => {
            this.props.setCurrentProductAccountStatuses(data.responseData);
            this.props.unBlockUi();
          });
      });
  }



  renderBasicDetailsForm() {
    let { currency = {}, accountType = {}, country = {} } = this.props.currentProductAccount.data;
    let formData;
    if (this.state.basicDetails !== undefined && this.state.basicDetails.id !== undefined) {
      formData = { ...this.state.basicDetails };
    } else {
      formData = {};
    }

    // function shoudLoadForm() {
    //   if (currency !== undefined && accountType !== undefined && country !== undefined) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }

    if (this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.aemform_basicDetails) {
      const properties = {
        accountId: this.props.match.params.accountId,
        formData,
        country: country.value,
        accountType: accountType.value,
        currency: currency.value,
        editType: 'capture-product-account-basic-details',
        pathname: this.props.history.location.pathname
      };
      var aemform = this.state.pageJson.par.aemform_basicDetails;
      var formRef = aemform.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform mode="edit"
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onBasicDetailTabDataSubmit}
            getFormData={this.getBasicDetails}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            flag={this.props.lang.currentLangFlag.flag}
          />
        );
      }
    }
  }

  renderPaperStatementForm() {
    let { currency, accountType, country } = this.state.currentAccount;
    let formData;
    if (this.state.paperStatementChequeBooks !== undefined) {
      formData = { ...this.state.paperStatementChequeBooks };
    } else {
      formData = { attentionOf: '' };
    }
    function shoudLoadForm() {
      if (currency !== undefined && accountType !== undefined && country !== undefined) {
        return true;
      } else {
        return false;
      }
    }
    if (shoudLoadForm() && this.state.pageJson !== undefined && this.state.pageJson.par.aemform_paperStatementsAndChequeBooks !== undefined) {
      const properties = {
        accountId: this.props.match.params.accountId,
        formData,
        country: country.value,
        accountType: accountType.value,
        currency: currency.value,
        editType: 'productPaperStatement',
        pathname: this.props.history.location.pathname
      };

      var aemform = this.state.pageJson.par.aemform_paperStatementsAndChequeBooks;
      var formRef = aemform.formRef;
      var pageTitle = "";
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform mode={'edit'}
            properties={properties}
            pageTitle={pageTitle}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onPaperStatementTabDataSubmit}
            optionsData={this.props.addresses || []}
            getFormData={this.getPaperData}
            history={this.props.history}
            pageState={this.state}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            flag={this.props.lang.currentLangFlag.flag}
            noOfChequeBooks={this.state.noOfChequeBooks || []}
            taxanomyURL={this.state.taxanomyURL}
            countrytaxanomyList={this.state.countrytaxanomyList}
            numberOfPaperStatements={this.state.numberOfPaperStatements || []}
          />
        );
      }
    }
  }

  setShouldDesignateAccountSpecificContact = (value, name) => {
    this.setState({ currentAccount: { ...this.state.currentAccount, accountSpecificContactDesignated: value } });
  }
  handleAccountEchannelReportingAARChange = (index, value) => {
    var _eChannelReporting = [...this.state.currentAccount.eChannelReporting];
    _eChannelReporting[index].autoAccountRegistration = value;
    this.setState({
      currentAccount: { ...this.state.currentAccount, eChannelReporting: _eChannelReporting },
    });
  }

  handleAccountEchannelReportingAARChange = (index, value) => {
    var _eChannelReporting = [...this.state.currentAccount.eChannelReporting];
    _eChannelReporting[index].autoAccountRegistration = value;
    this.setState({
      currentAccount: { ...this.state.currentAccount, eChannelReporting: _eChannelReporting },
    });
  }

  setShouldReportToEchannel = (value, name) => {
    if (value === true) {
      this.setState({
        currentAccount: {
          ...this.state.currentAccount,
          reportToEchannel: value
        }
      });
    } else {
      this.setState({
        currentAccount: {
          ...this.state.currentAccount,
          reportToEchannel: value,
          eChannelReporting: []
        },
        disabledeChannelReporting: [],
        noOfEchannelReportings: 1
      });
      this.reportingEchannelDisableList = []
    }
  }

  setAttentionFor = (value, name) => {
    this.setState({ currentAccount: { ...this.state.currentAccount, forTheAttentionOf: value } });
  }

  onAccountSignatoryAddition = () => {
    this.setState(prevState => {
      return {
        noOfAccountSignatories: prevState.noOfAccountSignatories + 1,
        showAddAccountSignatoryBtn: false
      }
    });
  }

  onAccountSignatoryDeletion = (index) => {
    let _accountSignatories = [...this.state.currentAccount.accountSignatories];
    let _delaccountSignatories = [...this.state.currentAccount.accountSignatories];
    _accountSignatories.splice(index, 1);
    var removeAccount = _delaccountSignatories.splice(index, 1)[0];
    let fiterRemoveAcount = removeAccount !== undefined ? removeAccount : ''
    let filterDisabledList = this.disableList.filter(id => id !== fiterRemoveAcount.id)
    this.disableList = filterDisabledList
    this.setState(prevState => {
      return {
        noOfAccountSignatories: prevState.noOfAccountSignatories - 1,
        currentAccount: { ...prevState.currentAccount, accountSignatories: _accountSignatories },
        showAddAccountSignatoryBtn: true,
        disabledAccountSignatory: filterDisabledList
      }
    });
  }

  onEchannelReportingAddition = () => {
    this.setState(prevState => {
      return {
        noOfEchannelReportings: prevState.noOfEchannelReportings + 1,
        showAddEchannelBtn: false
      }
    });
  }

  onEchannelReportingDeletion = (index) => {
    let _eChannelReporting = [...this.state.currentAccount.eChannelReporting];
    let _delreportingEchannel = [...this.state.currentAccount.eChannelReporting];
    _eChannelReporting.splice(index, 1);

    var removeAccount = _delreportingEchannel.splice(index, 1)[0];
    let fiterRemoveAcount = removeAccount !== undefined ? removeAccount : ''
    let filterDisabledList = this.reportingEchannelDisableList.filter(id => id !== fiterRemoveAcount.eChannelId)
    this.reportingEchannelDisableList = filterDisabledList

    this.setState(prevState => {
      return {
        noOfEchannelReportings: prevState.noOfEchannelReportings - 1,
        currentAccount: { ...prevState.currentAccount, eChannelReporting: _eChannelReporting },
        showAddEchannelBtn: true,
        disabledeChannelReporting: filterDisabledList
      }
    });
  }

  handleGroupSigningRestrictionsChange = (event) => {
    this.setState({
      currentAccount: { ...this.state.currentAccount, groupSigningRestrictions: event.target.value }
    });
  }

  toNextpage = () => {
    let payload = new SaveAndReturnPayload();
    payload.setPayload(this.state);
    this.props.reSetNewAccountActiveTabIndex();
    let accountPaperStatement = this.props.accountPaperStatement;
    var { productId } = this.props.match.params;
    let paperData = payload.data;
    let isPaperStatemet = this.checkPaperStatement(payload);
    if (isPaperStatemet === false || accountPaperStatement === true) {
      delete payload.data.paperStatementChequeBooks;
    }
    if (paperData.paperStatementChequeBooks !== undefined && paperData.paperStatementChequeBooks.paperStatementFrequency !== undefined) {
      if (paperData.paperStatementChequeBooks.paperStatementFrequency.value === "NR") {
        delete paperData.paperStatementChequeBooks.numberOfPaperStatements;
        delete paperData.paperStatementChequeBooks.perfferedDate;
        delete paperData.paperStatementChequeBooks.deliverTo;
        paperData.paperStatementChequeBooks.attentionOf = "";
      }
    }
    eapiClient("/product/account/" + productId, {
      method: 'PUT',
      data: JSON.stringify(paperData)
    })
      .then(({ data }) => {
        //resetting account DATA
        this.props.resetCurrentProductAccount();
        this.props.resetAccountPaperStatement();
        this.props.history.push('/case-body');
      });
  }

  getTabIndex = (index) => {
    this.props.setNewAccountActiveTabIndex(index);
  }
  CopytoAccountModalDailog = () => {
    this.setState({ CopytoAccountModalDailog: true });
  }
  toggleDialog = () => {
    this.setState({ CopytoAccountModalDailog: false });
    document.getElementById("copy_account_data_btn").focus();
  }
  setData = (event) => {
    var _copyData = [...this.state.copyData];
    if (event.target.checked && event.target.name === "1") {
      _copyData.push("addressandcontact");
    } else if (event.target.name === "1") {
      _copyData.remove("addressandcontact");
    }
    if (event.target.checked && event.target.name === "2") {
      _copyData.push("signatories");
    } else if (event.target.name === "2") {
      _copyData.remove("signatories");
    }
    if (event.target.checked && event.target.name === "3") {
      _copyData.push("echannel");
    } else if (event.target.name === "3") {
      _copyData.remove("echannel");
    }
    this.setState({ copyData: _copyData })
  }

  setAccountdata = (event) => {
    var _setAccountdata = [...this.state.to];
    if (event.target.checked) {
      _setAccountdata.push(event.target.id);
    } else {
      _setAccountdata.remove(event.target.id);
    }
    this.setState({ to: _setAccountdata });
  }

  onFormSubmitcopyData = (data) => {
    var payLoad = {};
    payLoad.copyData = this.state.copyData;
    payLoad.to = this.state.to;
    payLoad.from = this.props.currentProductAccount.data.id;

    eapiClient("/product/account/accountCopy", {
      method: 'POST',
      timeout: 30000,
      data: JSON.stringify(payLoad)
    })
      .then(({ data, status, headers }) => {
        if (status === 200) {
          this.setState({ CopytoAccountModalDailog: false });
        }
      })
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }
  translateWordForOption = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  checkHSBCnetEchannel = (echannelArray, selectedEchannel) => {
    let check = []
    check = echannelArray.filter(echannel => echannel.id === selectedEchannel)
    return (check.length > 0 && check[0].eChannelType.name === "HSBCnet") ? true : false
  }

  render() {
    let productDetailsArray = this.props.productDetails.account;
    let currentProductAccount = this.props.currentProductAccount.data;
    if (this.props.currentProductAccount.data.id !== undefined) {
      this.filterProductdetails = productDetailsArray.filter(item => item.id !== currentProductAccount.id)
    }
    let addAccountSignatoryButtonJsx = "";
    if (this.state.showAddAccountSignatoryBtn) {
      addAccountSignatoryButtonJsx = (
        <button className="gdocs-btn-default" onClick={this.onAccountSignatoryAddition}><i className="icon icon-add"></i> {this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.slotcontrol_slot1.addText) : ''} {this.state.noOfAccountSignatories + 1}</button>
      );
    }
    let addEchannelReportingButtonJsx = "";
    if (this.state.showAddEchannelBtn) {
      addEchannelReportingButtonJsx = (
        <button className="gdocs-btn-default" onClick={this.onEchannelReportingAddition}><i className="icon icon-add"></i>{`${this.state.pageEchannelReportingFormJson.par !== undefined ? this.translations(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.createText) : ''} ${this.state.noOfEchannelReportings + 1}`}</button>
      );
    }

    let eChannelReportingsJsx = [];
    for (var i = 1; i <= this.state.noOfEchannelReportings; i++) {
      eChannelReportingsJsx.push(<div className="echannel-reporting-wrapper" key={"eChannelReporting" + i}>
        <div className="echannel-reporting-position"><label for={`Echannel${i}`}></label>{this.state.pageEchannelReportingFormJson.par !== undefined ? this.translations(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.echannel) : ''} {i}</div>
        <div className="echannel-reporting-position">
          {(i > 1) ? <span className="delete-btn" role="button" onClick={this.onEchannelReportingDeletion.bind(this, i - 1)}><i className="icon icon-bin"></i></span> : ''}
          {
            this.props.currentProductAccount.echannels.length > 0 ?
              (
                <MultiLineSelect defaultValue={this.state.pageEchannelReportingFormJson.par !== undefined ? this.translations(this.state.pageEchannelReportingFormJson.par.static_text_pleaseSelect.text) : ''}
                  id={`Echannel${i}`}
                  requiredFields={{
                    "row1": ["eChannelType", "country"],
                    "row2": ["profileOwner"],
                    "row3": ["eChannelId"]
                  }}
                  formatters={{
                    "row1": [null, (data, fieldValue) => data.newEchannel ? `${fieldValue} (New)` : `${fieldValue} (Existing)`, null],
                    "row2": [],
                    "row3": []
                  }}
                  data={this.props.currentProductAccount.echannels || []}
                  value={this.state.currentAccount.eChannelReporting[i - 1] ? this.state.currentAccount.eChannelReporting[i - 1].eChannelId : ''}
                  disabledOptions={[...this.reportingEchannelDisableList, ...this.state.setDisabledonFlag]}
                  multiAccount={true}
                  _onChange={this.handleAccountEchannelReportingChange.bind(this, i - 1)} />
              ) : ''
          }
          <span className="icon icon-add addicon"></span>
          <PersistLink className="mrg-left"
            to={'/case-body/create-new-product-echannel'}
            history={this.props.history}
            state={this.state}
            data={`eChannelReporting${i}`}>
            {this.state.pageEchannelReportingFormJson.par !== undefined ? this.translations(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.createText) : ''}
          </PersistLink>
          {this.checkHSBCnetEchannel(this.props.currentProductAccount.echannels, this.state.currentAccount.eChannelReporting[i - 1] ? this.state.currentAccount.eChannelReporting[i - 1].eChannelId : '')
            && this.state.pageEchannelReportingFormJson.par !== undefined ?
            <div className="should-designate-account-wrapper1">
              <div className="AAR">
                {this.translations(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.aar)}
              </div>
              <div className="AAR1" role="radiogroup" >
                <label>
                  {
                    this.translateWordForRadio(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.options)[0].split('=')[1]
                  }
                  <Radiobutton
                    id={`Echannel_aar${i - 1}`}
                    setInputvalue={this.handleAccountEchannelReportingAARChange.bind(this, i - 1)}
                    name={`autoAccountRegistration${i - 1}`}
                    _value={this.state.currentAccount.eChannelReporting[i - 1] ? this.state.currentAccount.eChannelReporting[i - 1].autoAccountRegistration : ''}
                    value="true"
                  />
                </label>
                <label>
                  {
                    this.translateWordForRadio(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.options)[1].split('=')[1]
                  }
                  <Radiobutton
                    id={`Echannel_aar_no${i - 1}`}
                    setInputvalue={this.handleAccountEchannelReportingAARChange.bind(this, i - 1)}
                    name={`autoAccountRegistration${i - 1}`}
                    _value={this.state.currentAccount.eChannelReporting[i - 1] ? this.state.currentAccount.eChannelReporting[i - 1].autoAccountRegistration : ''}
                    value="false"
                  />
                </label>
              </div>
            </div> : ''}
        </div >
      </div >);
    }

    let mandate = "any-1-to-sign";
    if (this.state.currentAccount.mandateStructure) {
      mandate = this.state.currentAccount.mandateStructure.value;
    }
    let accountSignatoriesJsx = [];

    if (mandate === 'any-1-to-sign' || mandate === 'any-2-to-sign') {
      for (var i = 1; i <= this.state.noOfAccountSignatories; i++) {
        accountSignatoriesJsx.push(<div className="account-signatory-wrapper" key={i}>
          <div className="account-signatory-position">
            <label for={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSignatory1.title) : ''}>{this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSignatory1.title) : ''} {i}</label>
          </div>
          <div className="account-signatory-position">
            {(i > 1) ? <span className="delete-btn" role="button" onClick={this.onAccountSignatoryDeletion.bind(this, i - 1)}><i className="icon icon-bin"></i></span> : ''}
            {
              this.props.persons.length > 0 ?
                (
                  <MultiLineSelect
                    id={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSignatory1.title) + i : ''}
                    defaultValue={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.static_text_pleaseSelect.text) : ''}
                    requiredFields={{
                      "row1": ["firstName"],
                      "row2": ["dateOfBirth", "countryOfResidence", "nationality"],
                      "row3": []
                    }}
                    formatters={{
                      "row1": [
                        ({ firstName, lastName }) => firstName + " " + lastName
                      ],
                    }}
                    flag={true}
                    disabledOptions={this.state.disabledAccountSignatory}
                    data={this.props.persons || []}
                    value={this.state.currentAccount.accountSignatories[i - 1] ? this.state.currentAccount.accountSignatories[i - 1].id : ''}
                    onEdit={this.handleAccountSignatoryEditClick.bind(this, this.state.currentAccount.accountSignatories[i - 1])}
                    _onChange={this.handleAccountSignatoryChange.bind(this, i - 1)} />
                ) : ''
            }
            <span className="icon icon-add addicon"></span>
            <PersistLink className="mrg-left"
              to={'/case-body/create-new-product-signatory'}
              history={this.props.history}
              state={this.state}
              data={`accountSignatories${i}`}>
              {this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSignatory1.createText) : ''}
            </PersistLink>
          </div>
          <div className="restriction-container" id={`restriction-drop-down${i}`}>
            <div className="account-signatory-position">
              <label for={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidetextbox_individualRestrictions.title) : ''}>{this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidetextbox_individualRestrictions.title) : ''}</label>
            </div>

            <div className="account-signatory-position">
              <PrefixedInputBox name="restriction"
                value={this.state.currentAccount.accountSignatories[i - 1] ? this.state.currentAccount.accountSignatories[i - 1].restriction : ''}
                _onChange={this.setRestriction.bind(this, i)}
                maxLength="13"
                id={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidetextbox_individualRestrictions.title) + i : ''}
                prefix={this.state.basicDetails && this.state.basicDetails.currency && this.state.basicDetails.currency.name}
                aria-label={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidetextbox_individualRestrictions.title) : ''} />
            </div>
          </div>
          <div className="gdocs-clear-float"></div>
        </div>);
      }
      accountSignatoriesJsx.push(<div>{addAccountSignatoryButtonJsx}</div>);
    } else if (mandate === 'group-signature') {
      for (var i = 1; i <= this.state.noOfAccountSignatories; i++) {
        accountSignatoriesJsx.push(<div className="account-signatory-wrapper">
          <div className="account-signatory-position">
            <label for={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSignatory2.title) : ''}>{this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSignatory2.title) : ''} {i}</label>
          </div>
          <div className="account-signatory-position">
            {(i > 1) ? <span className="delete-btn" role="button" onClick={this.onAccountSignatoryDeletion.bind(this, i - 1)}><i className="icon icon-bin"></i></span> : ''}
            {
              this.props.persons.length > 0 ?
                (
                  <MultiLineSelect defaultValue={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.static_text_pleaseSelect.text) : ''}
                    id={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSignatory2.title) + i : ''}
                    requiredFields={{
                      "row1": ["firstName"],
                      "row2": ["dateOfBirth", "countryOfResidence", "nationality"],
                      "row3": []
                    }}
                    formatters={{
                      "row1": [
                        ({ firstName, lastName }) => firstName + " " + lastName
                      ],
                      "row3": [
                        ({ telephoneCountryCode, telephoneNumber }) => telephoneCountryCode.name.split(' ')[0] + " " + telephoneNumber,
                        ({ faxCountryCode, faxNumber }) => faxCountryCode.name.split(" ")[0] + " " + faxNumber
                      ]
                    }}
                    data={this.props.persons || []}
                    disabledOptions={this.state.disabledAccountSignatory}
                    value={this.state.currentAccount.accountSignatories[i - 1] ? this.state.currentAccount.accountSignatories[i - 1].id : ''}
                    onEdit={this.handleAccountSignatoryEditClick.bind(this, this.state.currentAccount.accountSignatories[i - 1])}
                    _onChange={this.handleAccountSignatoryChange.bind(this, i - 1)} />
                ) : ''
            }
            <span className="icon icon-add addicon"></span>
            <PersistLink className="mrg-left"
              to={'/case-body/create-new-product-signatory'}
              history={this.props.history}
              state={this.state}
              data={`accountSignatories${i}`}>
              {this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSignatory2.createText) : ''}
            </PersistLink>
          </div>
          <div className="restriction-container">
            <div className="account-signatory-position">
              <label for={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidedropdownlist_group["jcr:title"]) : ''}>{this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidedropdownlist_group["jcr:title"]) : ''}</label>
            </div>
            <div className="account-signatory-position">
              <div className="posRel">
                <select className="custom-drop-down" onChange={this.setAccountSignatoryGroup.bind(this, i)}
                  id={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidedropdownlist_group["jcr:title"]) : ''}
                  value={(this.state.currentAccount.accountSignatories[i - 1] && this.state.currentAccount.accountSignatories[i - 1].group) ? this.state.currentAccount.accountSignatories[i - 1].group.value : 'Please select'}>
                  <option value={this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.static_text_pleaseSelect.text) : ''} disabled>{this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidedropdownlist_group.mandatoryMessage) : ''}</option>
                  {
                    this.state.pageAccountSignatoryFormJson.guideContainer !== undefined && this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel !== undefined ?
                      this.translateWordForOption(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidedropdownlist_group.options).map((item, index) => (<option key={index} value={item.split('=')[0]}>{item.split('=')[1]}</option>))
                      : ''
                  }
                </select>
              </div>
            </div>
          </div>
          <div className="gdocs-clear-float"></div>
        </div>);
      }
      accountSignatoriesJsx.push(<div>{addAccountSignatoryButtonJsx}</div>);
      accountSignatoriesJsx.push(<hr></hr>);
      accountSignatoriesJsx.push(<div className="group-signing-wrapper">
        <div className="group-signing-position">
          {this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidetextbox_hasSignatureSupplied["jcr:title"]) : ''}
        </div>
        <div className="group-signing-position">
          <textarea onChange={this.handleGroupSigningRestrictionsChange} value={this.state.currentAccount.groupSigningRestrictions}></textarea>
          <p>{this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidetextbox_hasSignatureSupplied.placeHolderText) : ''} {this.state.currentAccount.currency ? this.state.currentAccount.currency.name : 'EUR'}</p>
        </div>
        <div className="gdocs-clear-float"></div>
      </div>);
    } else if (mandate === 'own-mandate') {
      accountSignatoriesJsx = (
        <div className="custom-mandate-note-wrapper">
          <p className="note">{this.state.pageAccountSignatoryFormJson.guideContainer !== undefined ? this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.static_text_ownMandateText._value) : ''}</p>
          <div className="owner-info">
            <p>{this.props.darkTitleBar.currentCase.caseOwner.name}</p>
          </div>
        </div>
      );
    }

    var basicDetailsHeading;
    var AccountAndAddressHeading;
    var paperStatementHeading;
    var AccountSignatoryHeading;
    var echannelHeading;

    if (this.state.pageJson !== undefined) {
      basicDetailsHeading = this.translations(this.state.pageJson.par.aemform_basicDetails.title);
      AccountAndAddressHeading = this.translations(this.state.pageJson.par.aemform_addresses.title);
      paperStatementHeading = this.translations(this.state.pageJson.par.aemform_paperStatementsAndChequeBooks.title);
      AccountSignatoryHeading = this.translations(this.state.pageJson.par.aemform_accountSignatories.title);
      echannelHeading = this.translations(this.state.pageJson.par.aemform_echannelReporting.title);
    }
    var countryName = this.state.countryName;
    if (paperStatementHeading !== undefined && countryName === 'Germany') {
      var statement = paperStatementHeading;
      var staArray = new Array();
      staArray = statement.split(" ");
      var germanStatement = staArray[0] + ' ' + staArray[1];
      paperStatementHeading = germanStatement;
    }

    document.title = this.state.currentAccount && this.state.currentAccount.id ?
      `${"Product Requests"} - ${"Review Product"} - ${`${this.state.currentAccount && this.state.currentAccount.accountType ? this.state.currentAccount.accountType.name + "," : ''} ${this.state.currentAccount.country.name} ${this.state.currentAccount && this.state.currentAccount.currency ? ", " + this.state.currentAccount.currency.name : ''}`} - ${'HSBC GLCM'}`
      : "Product Requests - Review Product - Accounts - HSBC GLCM";
    return (
      (this.state.currentAccount.id && this.state.pageJson !== undefined && this.state.pageAccountAndAddressFormJson.guideContainer !== undefined
        && this.state.pageAccountSignatoryFormJson.guideContainer !== undefined && this.state.pageEchannelReportingFormJson.par !== undefined)
        ? (<div className="product-account-container">
          <div className="pannel-heading-container">
            <h2 className="pannel-heading">
              {getConcatenatedStringFromValues(this.state.currentAccount.accountType && this.state.currentAccount.accountType.name, this.state.currentAccount.country &&
                this.state.currentAccount.country.name, this.state.currentAccount.currency && this.state.currentAccount.currency.name)}
            </h2>
            <p className="pannel-sub-heading">
              {getConcatenatedStringFromValues(this.state.currentAccount.accountHolder.name)}
              {this.state.currentAccount.accountTitle || this.state.currentAccount.tempRefrenceId ?
                " (" + getConcatenatedStringFromValues(this.state.currentAccount.accountTitle, this.state.currentAccount.tempRefrenceId) + ")" : ''}
            </p>
            <p className="optional-text">
              {this.translations(this.state.pageJson.par.page_title_mainTitle.descriptionText)}
            </p>
          </div>
          <div className="gdocs-clear-float"></div>
          <NavListAccordionWrapper open={this.props.displayTabIndex} resetAccordion={true} lang={this.props.lang.currentLang.lang}>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`${'1.'} ${basicDetailsHeading}`}
              status={this.props.currentProductAccount.statuses.basicDetails.status}
              _onClick={this.getTabIndex.bind(this, '0')}
            >
              <div>{this.renderBasicDetailsForm()}</div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`${'2.'} ${AccountAndAddressHeading}`}
              status={this.props.currentProductAccount.statuses.addressAndContact.status}
              _onClick={this.getTabIndex.bind(this, '1')}
            >
              <div className="account-address-and-contact-section">
                <p>
                  {this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountAddress.helpText)}
                </p>
                <div className="address-wrapper">
                  <div className="address-position">
                    <label for="accountAddress">{this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountAddress.title)}</label>
                  </div>
                  <div className="address-position">
                    {
                      (this.props.addresses !== undefined && this.props.addresses.length > 0)
                        ? (<SingleLineSelect
                          defaultValue={this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                          requiredFields={["addressLine1", "addressLine2", "addressLine3", "city", "state", "country"]}
                          optionsData={this.props.addresses || []}
                          id="accountAddress"
                          _value={this.state.currentAccount.accountSpecificAddress}
                          onEdit={this.handleAccountAddressEditClick}
                          _onChange={this.handleAccountAddressChange}
                        />
                        )
                        : ''
                    }
                    <span className="icon icon-add addicon">
                      <PersistLink
                        className="mrg-left"
                        to={'/case-body/create-new-product-address'}
                        history={this.props.history}
                        state={this.state}
                        data="accountAddress"
                      >
                        {this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountAddress.createText)}
                      </PersistLink></span>
                  </div>
                </div>
                <div className="address-wrapper">
                  <div className="address-position">
                    <label for={this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guidetextbox_forTheAttoff.title)}>{`${this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guidetextbox_forTheAttoff.title)} ${this.state.currentAccount.accountSpecificAddress === undefined ? this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guidetextbox_forTheAttoff.titleOption) : ''}`}</label>
                  </div>
                  <div className="address-position">
                    <Inputbox
                      name={this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guidetextbox_forTheAttoff.title)}
                      setInputvalue={this.setAttentionFor}
                      _value={this.state.currentAccount.forTheAttentionOf}
                    />
                  </div>
                </div>
                <div className="should-designate-account-wrapper">
                  <div className="should-designate-account-position">
                    {this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guideradiobutton_designateAccountSpecificContact.title)}
                  </div>
                  <div className="should-designate-account-position" role="radiogroup" aria-label={this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guideradiobutton_designateAccountSpecificContact['jcr:title'])}>
                    <label>
                      {this.translateWordForRadio(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guideradiobutton_designateAccountSpecificContact.options)[0].split('=')[1]}
                      <Radiobutton
                        setInputvalue={this.setShouldDesignateAccountSpecificContact}
                        name="shouldDesignateAccountSpecificContact"
                        _value={this.state.currentAccount.accountSpecificContactDesignated}
                        value="true"
                      />
                    </label>
                    <label>
                      {this.translateWordForRadio(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guideradiobutton_designateAccountSpecificContact.options)[1].split('=')[1]}
                      <Radiobutton
                        setInputvalue={this.setShouldDesignateAccountSpecificContact}
                        name="shouldDesignateAccountSpecificContact"
                        _value={this.state.currentAccount.accountSpecificContactDesignated}
                        value="false"
                      />
                    </label>
                  </div>
                </div>
                {
                  this.state.currentAccount.accountSpecificContactDesignated ? (
                    <div className="account-contact-wrapper">
                      <div className="account-contact-position">
                        {this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSpecificContact.title)}
                      </div>
                      <div className="account-contact-position">
                        {
                          (this.props.persons !== undefined && this.props.persons.length > 0) ?
                            (<MultiLineSelect defaultValue={this.state.pageAccountAndAddressFormJson !== undefined ? this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text) : ''}
                              requiredFields={{
                                "row1": ["title", "firstName", "jobTitle"],
                                "row2": ["emailAddress"],
                                "row3": ["telephoneNumber", "faxNumber"]
                              }}
                              requiredFieldsPrefixes={{
                                "row1": ["", "", "", ""],
                                "row2": [""],
                                "row3": ["Tel", "Fax"]
                              }}
                              formatters={{
                                "row1": [
                                  ({ title, other }) => title && title.value === 'other' && other ? other : title.value !== 'other' ? title.name : '',
                                  ({ firstName, lastName }) => firstName + " " + lastName
                                ],
                                "row3": [
                                  ({ telephoneNumber }) => telephoneNumber !== undefined ? telephoneNumber : '',
                                  ({ faxNumber }) => faxNumber !== undefined ? faxNumber : ''
                                ]
                              }}
                              data={this.props.persons || []}
                              lang={this.props.lang}
                              salutations={this.state.pageJson.par !== undefined ? this.state.pageJson.par.aemform_accountSignatories.salutation : ''}
                              value={this.state.currentAccount.accountSpecificContact}
                              onEdit={this.handleAccountContactEditClick.bind(this, this.state.currentAccount.accountSpecificContact)}
                              _onChange={this.handleAccountContactChange} />) : ''
                        }
                        <span className="icon icon-add addicon">
                          <PersistLink
                            className="mrg-left"
                            to={'/case-body/create-new-product-contact'}
                            history={this.props.history}
                            state={this.state}
                            data="accountSpecificContact"
                          >
                            {this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guideMultiDropdownlist_accountSpecificContact.createText)}
                          </PersistLink></span>
                      </div>
                    </div>)
                    : ''
                }
                <div className="gdocs-clear-float"></div>
                <div key="buttons-wrapper" className="form-buttons-save-section">
                  <div className="form-buttons-wrapper">
                    <button className="gdocs-btn-submit"
                      onClick={this.onAccountAddressAndContactsTabDataSubmit}
                    >
                      {this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guidebutton_submit.text)}
                    </button>
                  </div>
                </div>
              </div>
            </NavListAccordion>
            {
              this.state.showPaperStamentsAndChequeBooksSection ? (
                <NavListAccordion
                  lang={this.props.lang.currentLang.lang}
                  navAccHeading={`${'3.'} ${paperStatementHeading}`}
                  status={this.props.currentProductAccount.statuses.paperStatement.status}
                  _onClick={this.getTabIndex.bind(this, '2')}
                >
                  <div className="addresses-section-new-account">
                    <div>
                      {
                        (this.props.currentProductAccount.data.id && this.props.paperStatementChequeBooksFormMode !== undefined)
                          ? this.renderPaperStatementForm()
                          : ''
                      }
                    </div>
                  </div>
                </NavListAccordion>
              ) : ''
            }
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={this.state.showPaperStamentsAndChequeBooksSection ? `${'4.'} ${AccountSignatoryHeading}` : `${'3.'} ${AccountSignatoryHeading}`}
              status={this.props.currentProductAccount.statuses.accountSignatories.status}
              _onClick={this.getTabIndex.bind(this, `${this.state.showPaperStamentsAndChequeBooksSection ? '3' : '2'}`)}
            >
              <div className="account-signatories-section">
                <div className="mandate-structure-wrapper">
                  <div className="mandate-structure-position">
                    <label for="mandateStructure">
                      {this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidedropdownlist_selectedMandate.title)}
                    </label>
                  </div>
                  <div className="mandate-structure-position">
                    <div className="posRel">
                      <SimpleDropdown
                        id="mandateStructure"
                        defaultValue={this.translations(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.static_text_pleaseSelect.text)}
                        value={this.state.currentAccount.mandateStructure ? this.state.currentAccount.mandateStructure.value : ""}
                        _onChange={this.setMandateStructure}
                        options={this.translateWordForOption(this.state.pageAccountSignatoryFormJson.guideContainer.rootPanel.items.guidedropdownlist_selectedMandate.options)}
                        mode="aem" />
                    </div>
                  </div>
                  <div className="gdocs-clear-float"></div>
                </div>
                {accountSignatoriesJsx}
                <div className="gdocs-clear-float"></div>
                <div key="buttons-wrapper" className="form-buttons-save-section">
                  <div className="form-buttons-wrapper">
                    <button className="gdocs-btn-submit" onClick={this.onAccountSignatoryTabDataSubmit}>
                      {this.translations(this.state.pageAccountAndAddressFormJson.guideContainer.rootPanel.items.guidebutton_submit.text)}
                    </button>
                  </div>
                </div>
              </div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={this.state.showPaperStamentsAndChequeBooksSection ? `${'5.'} ${echannelHeading}` : `${'4.'} ${echannelHeading}`}
              status={this.props.currentProductAccount.statuses.eChannelReporting.status}
              id="eChannel-reporting"
              _onClick={this.getTabIndex.bind(this, `${this.state.showPaperStamentsAndChequeBooksSection ? '4' : '3'}`)}
            >
              <div className="echannel-reporting-section">
                <p>
                  {this.translations(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.description)}
                </p>
                <div className="should-report-echannel-wrapper">
                  <div className="should-report-echannel-position">
                    {this.translations(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.reportAccount)}
                  </div>
                  <div
                    className="should-report-echannel-position"
                    role="radiogroup"
                    aria-label={this.translations(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.reportAccount)}
                  >
                    <label>
                      {
                        this.translateWordForRadio(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.options)[0].split('=')[1]
                      }
                      <Radiobutton
                        setInputvalue={this.setShouldReportToEchannel}
                        name="setShouldReportToEchannel"
                        _value={this.state.currentAccount.reportToEchannel}
                        value="true"
                      />
                    </label>
                    <label>
                      {
                        this.translateWordForRadio(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.options)[1].split('=')[1]
                      }
                      <Radiobutton
                        setInputvalue={this.setShouldReportToEchannel}
                        name="setShouldReportToEchannel"
                        _value={this.state.currentAccount.reportToEchannel}
                        value="false"
                      />
                    </label>
                  </div>
                </div>
                {
                  this.state.currentAccount.reportToEchannel
                    ? eChannelReportingsJsx
                    : ''
                }
                <div className="gdocs-clear-float"></div>
                {
                  this.state.currentAccount.reportToEchannel
                    ? addEchannelReportingButtonJsx
                    : ''
                }
              </div>
              <div className="gdocs-clear-float"></div>
              <div key="buttons-wrapper" className="form-buttons-save-section">
                <div className="form-buttons-wrapper">
                  <button className="gdocs-btn-submit" onClick={this.onEchannelReportingTabDataSubmit}>
                    {this.translations(this.state.pageEchannelReportingFormJson.par.static_text_echannelReporting.saveRefresh)}
                  </button>
                </div>
              </div>
            </NavListAccordion>
          </NavListAccordionWrapper>
          <div className="btn-wrapper">
            <div className="save-btn-left">
              <button
                id="copy_account_data_btn"
                onClick={this.CopytoAccountModalDailog}
                className='gdocs-btn-default'
              >
                {this.translations(this.state.pageJson.par.button_copyDataToOrFromAnotherAccount.text)}
              </button>
              <button
                className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon"
                data-tooltip="copyData"
                tabIndex="0"
                aria-expanded={false}
                aria-describedby="copyDataContent"
                aria-label="More information on Copy Account Data"
                onMouseEnter={this.toggleTooltip}
                onMouseLeave={this.toggleTooltip}
                onClick={this.toggleTooltip}
                onKeyUp={(event) => this.toggleTooltiponEnter(event)}
                style={{
                  background: "white",
                  border: "inherit"
                }}
              >
              </button>
              <Tooltip role="tooltip"
                active={this.state.showTooltip}
                position="right"
                arrow="center"
                parent="copyData"
              >
                <div className="tooltip-content-hintText">
                  <span role="status" id="copyDataContent">{this.translations(this.state.pageJson.par.button_hintText.text)}</span>
                </div>
              </Tooltip>
            </div>
            <div className="save-btn-right">
              <button onClick={this.toNextpage} className='btn save-btn'>
                {this.translations(this.state.pageJson.par.button_saveAndReturn.text)}
              </button>
            </div>

          </div>
          <CopytoAccountModal
            showDialog={this.state.CopytoAccountModalDailog}
            copyToaccountformJson={this.state.copyToaccountformJson}
            toggleDialog={this.toggleDialog}
            history={this.props.history}
            _setData={this.setData}
            _onFormSubmitcopyData={this.onFormSubmitcopyData}
            _filteredAccount={this.filterProductdetails}
            _setAccountdata={this.setAccountdata}
            bsClass="copy-to-account-modal-content"
            translations={(word) => this.translations(word)}
            translateWord={(word) => this.translateWord(word)}
            translateWordForOption={(word) => this.translateWordForOption(word)} />
        </div>
        ) : '');
  }
}

// Basic Detail
class BasicDetail {
  constructor() {
    this.data = {}
  }

  setBasicDetailPayload({ basicDetails }) {

    if (basicDetails.currency === '') {
      basicDetails.currency = { name: '', value: '' }
    }
    if (basicDetails.accountType === '') {
      basicDetails.accountType = { name: '', value: '' }
    }
    this.data = { ...basicDetails }
  }
}

// Account address and Contact
class AccountAddressAndContact {
  constructor() {
    this.data = {}
  }

  setAccountAddressAndContact({ currentAccount, caseId }) {
    this.data.caseId = caseId;
    this.data.accountSpecificContactDesignated = currentAccount.accountSpecificContactDesignated;
    this.data.forTheAttentionOf = currentAccount.forTheAttentionOf;
    if (currentAccount.accountSpecificContact) {
      this.data.accountSpecificContact = currentAccount.accountSpecificContact;
    } else {
      if (currentAccount.accountSpecificContactDesignated === false) {
        this.data.accountSpecificContact = undefined;
      }
    }
    if (currentAccount.accountSpecificAddress) {
      this.data.accountSpecificAddress = currentAccount.accountSpecificAddress;
    }
  }
}

// Paper Statement
class PaperStatementAndChequeBooks {
  constructor() {
    this.data = {}
  }
  setPaperStatementAndChequeBooks({ paperStatementChequeBooks }) {
    this.data = { paperStatementChequeBooks }
  }
}

// Account Signatory
class AccountSignatoy {
  constructor() {
    this.data = {}
  }

  setAccountSignatoy({ currentAccount, caseId }) {
    this.data.caseId = caseId;
    //this.data.accountSignatories = currentAccount.accountSignatories;
    this.data.accountSignatories = currentAccount.accountSignatories.map(item => {
      if (item.group === undefined) {
        item.group = {
          id: 'Group A',
          value: 'Group A'
        }
      }
      return item;
    })
    this.data.mandateStructure = currentAccount.mandateStructure;
    if (currentAccount.mandateStructure && currentAccount.mandateStructure.id === "group-signature") {
      this.data.groupSigningRestrictions = currentAccount.groupSigningRestrictions;
    } else {
      this.data.groupSigningRestrictions = undefined;
    }
  }
}

// Echannel Reporting
class EchannelReporting {
  constructor() {
    this.data = {}
  }

  setEchannelReporting({ currentAccount, caseId }) {
    this.data.caseId = caseId;
    this.data.reportToEchannel = currentAccount.reportToEchannel;
    this.data.eChannelReporting = currentAccount.eChannelReporting;
  }
}

// Final Payload

class SaveAndReturnPayload {
  constructor() {
    this.data = {};
  }
  setPayload({ basicDetails, currentAccount, accountContact, accountAddress, paperStatementChequeBooks }) {
    if (basicDetails.currency === '') {
      basicDetails.currency = { name: '', value: '' }
    }
    if (basicDetails.accountType === '') {
      basicDetails.accountType = { name: '', value: '' }
    }
    this.data = { ...basicDetails, paperStatementChequeBooks };
    //merging data from currentAccount to basicDetails
    this.data.accountSignatories = currentAccount.accountSignatories.map(item => {
      if (item.group === undefined) {
        item.group = {
          id: 'Group A',
          value: 'Group A'
        }
      }
      return item;
    });
    if (currentAccount.mandateStructure && currentAccount.mandateStructure.id === "group-signature") {
      this.data.groupSigningRestrictions = currentAccount.groupSigningRestrictions;
    } else {
      this.data.groupSigningRestrictions = undefined;
    }
    this.data.eChannelReporting = currentAccount.eChannelReporting;
    this.data.mandateStructure = currentAccount.mandateStructure;
    this.data.accountSpecificContactDesignated = currentAccount.accountSpecificContactDesignated;
    this.data.reportToEchannel = currentAccount.reportToEchannel;
    this.data.forTheAttentionOf = currentAccount.forTheAttentionOf;

    if (currentAccount.accountSpecificContact) {
      this.data.accountSpecificContact = currentAccount.accountSpecificContact;
    } else {
      if (currentAccount.accountSpecificContactDesignated === false) {
        this.data.accountSpecificContact = undefined;
      }
    }
    if (currentAccount.accountSpecificAddress) {
      this.data.accountSpecificAddress = currentAccount.accountSpecificAddress;
    }
  }
}

const mapStateToProps = state => {
  return {
    currentProductAccount: state.currentProductAccount,
    productDetails: state.productDetails,
    persons: state.persons,
    addresses: state.addresses,
    darkTitleBar: state.darkTitleBar,
    paperStatementChequeBooksFormMode: (state.currentProductAccount.data.paperStatementChequeBooks && Object.keys(state.currentProductAccount.data.paperStatementChequeBooks).length > 0) ? 'edit' : '',
    displayTabIndex: state.currentProductAccount.activeTabIndex,
    lang: state.lang,
    countryInfo: state.countryInfo,
    accountPaperStatement: state.accountPaperStatement
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setCurrentProductAccount: productsAccountData => {
      dispatch(setCurrentProductAccount(productsAccountData))
    },
    resetCurrentProductAccount: () => {
      dispatch(resetCurrentProductAccount())
    },
    setCurrentProductAccountEchannels: echannels => {
      dispatch(setCurrentProductAccountEchannels(echannels))
    },
    setCurrentProductAccountStatuses: statuses => {
      dispatch(setCurrentProductAccountStatuses(statuses));
    },
    setAddresses: addresses => {
      dispatch(setAddresses(addresses));
    },
    setPersons: persons => {
      dispatch(setPersons(persons));
    },
    setCountryInfo: assocaitions => {
      dispatch(setCountryInfo(assocaitions))
    },
    setCurrencyInfo: currencyInfo => {
      dispatch(setCurrencyInfo(currencyInfo))
    },
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    setNewAccountActiveTabIndex: index => {
      dispatch(setNewAccountActiveTabIndex(index))
    },
    reSetNewAccountActiveTabIndex: () => {
      dispatch(reSetNewAccountActiveTabIndex())
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
    resetAccountPaperStatement: () => {
      dispatch(resetAccountPaperStatement())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureProductNewAccount);


// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductNewAccount/index.js